var ToggleViewModel;

ToggleViewModel = (function() {
  function ToggleViewModel(options) {
    options = options || {};
    this.affirmativeText = ko.asObservable(options.affirmativeText != null ? options.affirmativeText : 'yes');
    this.negativeText = ko.asObservable(options.negativeText != null ? options.negativeText : 'no');
    this.value = ko.asObservable(options.value != null ? options.value : false);
    this.disabled = ko.asObservable(options.disabled != null ? options.disabled : false);
  }

  return ToggleViewModel;

})();
